import controller from './admin-konv.controller';
import template from './admin-konv.html';
import './admin-konv.scss';

export default {
	controller,
	controllerAs: '$ctrl',
	path:         '/admin/konv',
	template,
	title:        'menu.admin-konv',
};
